<template>
        <!-- Modal -->
        <div class="modal fade" id="changeUserStateModal" tabindex="-1" aria-labelledby="changeUserStateModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                        <div class="modal-content">
                                <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Cambiar Estado de Usuario</h5>
                                        <button v-if="state == 'form'" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                        </button>
                                </div>
                                <div class="modal-body">
                                    <div v-if="state == 'form'">
                                        <p>{{ question_message }}</p>
                                    </div>
                                    <div v-if="state == 'load'">
                                        <img :src="require('@/assets/images/system/Spinner.gif')" class="mx-auto d-block" width="150" height="150" border="0"> 
                                    </div>
                                    <div v-if="state == 'successfully'">
                                        <p>{{ success_message }}</p>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <div v-if="state == 'form'">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                                        <button type="button" class="btn btn-success" v-if="status == false " @click="activeUserMethod">Activar Usuario</button>
                                        <button type="button" class="btn btn-success" v-if="status == true " @click="inactiveUserMethod">Desctivar Usuario</button>
                                    </div>
                                    <div v-if="state == 'successfully'">
                                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="reset_state" >Aceptar</button>
                                    </div>
                                </div>
                        </div>
                </div>
        </div>
</template>

<script>
import { mapActions } from 'vuex'
import '../../assets/images/system/Spinner.gif'

export default {
        name: 'changeUserState',
        data(){
                return {
                        state: 'form',
                        id: '',
                        status: '',
                        question_message: '',
                        success_message: ''
                }
        },
        props:{
            user_id: String,
            user_name: String,
            user_status: String
        },
        methods: {
                ...mapActions([
                                'activeUser',
                                'inactiveUser'
                        ]),
                async activeUserMethod(){
                    this.state = "load"
                    const payload = {
                            id: this.id,
                    }
                    let status = await this.activeUser(payload)
                    if(status.data.status == 'ok'){
                            this.state = "successfully"
                            this.emitSuccess()
                    }

                },
                async inactiveUserMethod(){
                    this.state = "load"
                    const payload = {
                            id: this.id,
                    }
                    let status = await this.inactiveUser(payload)
                    if(status.data.status == 'ok'){
                            this.state = "successfully"
                            this.emitSuccess()
                    }

                },
                reset_state(){
                        this.state = "form"
                },
                setMessage(user){
                    if(this.status){
                        this.question_message = "¿Seguro que desea Desactivar el acceso del usuario: "+user
                        this.success_message = "El acceso del usuario "+user+" Ha sido desactivado"
                    }
                    else{
                        this.question_message = "¿Seguro que desea activar el acceso del usuario: "+user
                        this.success_message = "El acceso del usuario "+user+" Ha sido activado"
                    }
                },
                emitSuccess(){
                        this.$emit('statusChanged')
                }
        },
        updated(){
                this.id = this.user_id
                this.status = this.user_status
                this.setMessage(this.user_name)
        }

}
</script>

<style>
</style>

